import { Stack, Typography } from "@mui/material";

export default function Footer() {
  return (
    <Stack direction="row" justifyContent="space-between" px={25} pt={2}>
      <img src={require("../Assets/Images/footer.avif")} alt="" style={{ width: "30%" }} />

      <Stack width="395px" spacing={2} pt={5}>
        <Typography color="#20487E" variant="h3" fontWeight="bold">
          Vervolgstappen
        </Typography>

        <Typography fontSize="24px" color="#888">
          Na afloop van onze tussentijdse presentatie zullen we één concept selecteren. Met verdere
          brainstormsessies, prototyping en tests zullen we dit concept uitwerken tot een volledige
          ontwerpoplossing.
        </Typography>
      </Stack>
    </Stack>
  );
}
